module.exports = __webpack_public_path__ + "img/profile01.9c4cc067.jpg";